export enum EDeductionStatus {
  Active = "Active",
  Inactive = "Inactive",
  Expired = "Expired",
  Exhausted = "Exhausted"
}
